import { useRef, useState, useEffect } from 'react'
import { HAVE_WINDOW } from 'src/constants'

import './StripeText.scss'

interface StripeTextProps {
  text: string
}

export default function StripeText({ text }: StripeTextProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLParagraphElement>(null)
  const [shouldScroll, setShouldScroll] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!containerRef.current || !textRef.current) {
      return
    }

    const containerWidth = containerRef.current.offsetWidth
    const textWidth = textRef.current.scrollWidth

    setShouldScroll(textWidth > containerWidth)
  }, [text, textRef, containerRef])

  useEffect(() => {
    if (!HAVE_WINDOW) {
      return
    }

    const observer = new window.IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    )

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={containerRef} className="stripe-container">
      <p
        ref={textRef}
        className={`whitespace-nowrap ${
          shouldScroll && isVisible
            ? 'animate-vertical-to-show-all-text w-80'
            : ''
        }`}
      >
        {text}
      </p>
    </div>
  )
}
